// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"b309ba47","167":"ba7a7de9","321":"73db4026","378":"3c37f1ad","412":"a3798c3f","649":"eb0f9f83","987":"5a4a530f"}[chunkId] + ".chunk.js";
};